import React from "react"
import ModalDialog from "../../components/elements/ModalDialog"
import Button from "../../components/elements/Button"
import { useAppDispatch } from "../../hooks"
import { reset } from "../measurement/measurementSlice"
import { resetError } from "./errorSlice"
import { NQError, NQErrorCode } from "@visonum/network-quality-sdk"
import t from "../../helper/t"
import SmartLink from "../../components/elements/SmartLink"
import { NQInternalError, NQInternalErrorCode } from "@visonum/network-quality-sdk/dist/src/main/NQError"

interface ErrorDialogProps {
  lastError: Error
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ lastError }) => {
  function errorTitle(lastError: Error): string {
    if (lastError instanceof NQError && lastError.code == NQErrorCode.SystemUnderMaintenance) {
      return t("Wartungsarbeiten");
    } else {
      return t("Es ist ein Fehler aufgetreten");
    }
  }

  function errorMessage(lastError: Error): string {
    if (lastError instanceof NQError) {
      switch (lastError.code) {
        case NQErrorCode.Server:
          return t("Der Speedtest-Server steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später noch einmal.");
        case NQErrorCode.Client:
          return t("Ein interner Fehler ist aufgetreten.");
        case NQErrorCode.Connectivity:
          return t("Während der Messung ist ein unerwarteter Fehler aufgetreten. Bitte versuch es später noch einmal.");
        case NQErrorCode.SystemUnderMaintenance:
          return t("Das System wird zurzeit gewartet. Bitte versuchen Sie es später noch einmal.");
        case NQErrorCode.RateLimit:
          return t("Du hast die maximal zulässige Anzahl von Speedtests für heute erreicht. Ab morgen steht Dir unser System wieder zur Verfügung. Die Begrenzung dient dem Schutz unseres Netzes und anderer Nutzer.");
        case NQErrorCode.ParallelSpeedtests:
          return t("Wir haben festgestellt, dass möglicherweise bereits ein Speedtest von diesem Anschluss durchgeführt wird. Bitte wart in ein paar Minuten vor dem Start eines neuen Speedtests.");
      }
    } else {
      return t("Ein interner Fehler ist aufgetreten.")
    }
  }

  const internalErrorCodeToNumber = (code: NQInternalErrorCode) => {
    switch (code) {
      case NQInternalErrorCode.RemotePortDetection: return 1;
      case NQInternalErrorCode.MissingNQValueDuringSave: return 2;
      case NQInternalErrorCode.IllegalBenchmarkResultsValues: return 3;
      case NQInternalErrorCode.DownloadError: return 4;
      case NQInternalErrorCode.DownloadTimeout: return 5;
      case NQInternalErrorCode.UploadError: return 6;
      case NQInternalErrorCode.UploadTimeout: return 7;
    }
  }

  const unknownErrorNumber = 1000;
  const nqErrorMultiplier = 30;
  const errorShift = 100;

  const getErrorNumber = (error: Error) => {
    if (error instanceof NQError) {
      const cause = error.cause;
      const addNumber = cause instanceof NQInternalError ? internalErrorCodeToNumber(cause.internalCode) : 0;
      return errorShift + error.code * nqErrorMultiplier + addNumber;
    }

    return unknownErrorNumber;
  }

  const title = errorTitle(lastError);
  const message = errorMessage(lastError);
  const errorNumber = getErrorNumber(lastError);

  const dispatch = useAppDispatch()
  function clickHandler() {
    dispatch(resetError());
    dispatch(reset());
  }

  return (
    <ModalDialog>
      <h2>{title}</h2>
      <p style={{ marginBottom: 0 }}>{message}</p>
      <p style={{ marginBottom: 36 }}>{t("Fehlernummer")}: {errorNumber}</p>
      <SmartLink href="/" onClick={clickHandler}>
        <Button>
          {t("Ok")}
        </Button>
      </SmartLink>
    </ModalDialog>
  )
}

export default ErrorDialog;